export default __webpack_public_path__ + "static/media/icon.edit.c9b6201c.svg";